import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import fileSize from 'filesize';
import styled from 'styled-components';

import { colors } from '../../../shared/styles';
// import { getAuthToken } from '../../utils';
import { getDownloadUrl } from '../../../redux/reducers/download';
import {
    clearUploadField,
    createUploadField,
    startUpload,
} from '../../../redux/reducers/asset';

const StyledUploader = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;
    font-size: 13px;

    & .dropzone-wrapper {
        color: ${colors.white};
        background: ${colors.orange.default};
        border-radius: 4px;
    }

    & .dropzone-wrapper-error {
        color: ${colors.white};
        background: ${colors.error.default};
    }

    & .dropzone-wrapper div {
        padding: 10px;
    }

    & .tracker__bar {
        box-sizing: border-box;
        width: 100%;
        padding: 4px;
        background: ${colors.white};
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
    }

    & .tracker__bar-inside {
        box-sizing: border-box;
        color: ${colors.white};
        background: ${colors.orange.default};
        padding: 6px 10px;
        border-radius: 4px;
        min-width: 40px;
    }

    & .details {
        background: ${colors.white};
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        padding: 10px;
        text-align: center;
    }

    & .details img {
        border-radius: 4px;
        margin-bottom: 10px;
    }

    & .details .filename {
        padding-bottom: 10px;
    }

    & .details button {
        color: ${colors.white};
        background: ${colors.orange.default};
        border-radius: 4px;
        border: none;
        padding: 6px 10px;
        margin-right: 10px;
    }

    &.input-error {
        span {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }

    & .image_preview {
        margin-bottom: 10px;
        height: 140px;
        width: 100%;
        display: block;
        position: relative;
        overflow: hidden;
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
    }
`;

class S3UploadField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
        };

        // const existingValue = props.input.value;

        // bind local functions on construction rather than in every render cycle
        this.onClearUpload = this.onClearUpload.bind(this);
        this.onDownload = this.onDownload.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(
            createUploadField(this.props.input.name, this.props.input.value)
        );
    }

    onClearUpload(e) {
        e.preventDefault();

        this.props.dispatch(clearUploadField(this.props.input.name));

        if (this.props.onRemove) {
            return this.props.onRemove();
        }

        this.props.input.onChange(null);
        this.props.dispatch(createUploadField(this.props.input.name));
    }

    onDownload(e) {
        e.preventDefault();

        const assetId = this.props.assetField.assetId;
        const fetchingDownload = this.props.fetchingDownloads[assetId] === true;
        const downloadUrl = this.props.downloadUrlsById[assetId];

        // already have the url, no no to request the signed URL
        if (downloadUrl) {
            return window.open(downloadUrl, '_blank');
        }

        // // in the process of requesting a download
        if (fetchingDownload) {
            return null;
        }

        // no signed url yet, or the previous request failed
        this.props.dispatch(getDownloadUrl(assetId, true));

        return null;
    }

    handleDrop(files) {
        let error = null;

        // const authToken = getAuthToken();

        // if (!authToken || !authToken.length > 0) {
        //     error = 'You must be logged in to upload files.';
        // }

        const size = files[0].size;
        const maxFileSize = this.props.maxFileSize;

        if (!this.props.multiple && files.length > 1) {
            error = 'Only drop one file';
        } else if (maxFileSize && size > maxFileSize) {
            const sizeMb = (size / 1024 / 1024).toFixed(2);
            const maxMb = (maxFileSize / 1024 / 1024).toFixed(2);
            error = `File must be smaller than ${maxMb}mb. Yours is ${sizeMb}mb.`;
        }

        this.setState({ error });

        if (error) {
            return;
        }

        this.props
            .dispatch(
                startUpload(
                    this.props.input.name,
                    files[0],
                    this.props.assetType
                )
            )
            .then(result => {
                this.props.input.onChange(result);
            });
    }

    renderImagePreview(assetField) {
        if (!assetField || !assetField.previewUrl) {
            return null;
        }

        if (!assetField.previewUrl.match(/\.(jpeg|jpg|gif|png)/)) {
            return null;
        }

        const imgSrc =
            assetField.related && assetField.related.result_thumb_640
                ? assetField.related.result_thumb_640.url
                : assetField.previewUrl;

        const imageStyle = {
            backgroundImage: `url(${imgSrc})`,
        };

        return <div className="image_preview" style={imageStyle} />;
    }

    render() {
        const { error } = this.state;
        const metaError = this.props.meta.touched
            ? this.props.meta.error
            : null;

        const {
            assetField,
            selectText,
            disabled,
            disableDownloadButton,
        } = this.props;

        const isUploading = assetField
            ? assetField.status === 'UPLOADING'
            : false;
        const isProcessing = assetField
            ? assetField.status === 'PROCESSING'
            : false;
        const hasCompleted = assetField
            ? assetField.status === 'COMPLETE'
            : false;
        const progress = assetField ? assetField.uploadProgress : 0;

        const assetId = assetField ? assetField.assetId : null;

        const fetchingDownloads = this.props.fetchingDownloads;
        const downloadDisabled = fetchingDownloads[assetId] === true;
        // const hasExistingFile = value && value.assetId;
        const progressText = isProcessing
            ? 'Processing, please wait...'
            : `${progress}%`;
        const hideDz = isUploading || isProcessing || hasCompleted;

        const showDetails = !isUploading && !isProcessing && hasCompleted;

        const fileName = assetField ? assetField.fileName : '';
        const size = assetField ? assetField.fileSize : null;
        const prettySize = size ? fileSize(size) : '';

        const fileExt =
            fileName && fileName.length > 0 ? fileName.split('.').pop() : '';
        let prettyFilename = '';

        if (fileName && fileName.length > 0) {
            prettyFilename =
                fileName.length > 25
                    ? `${fileName.substring(0, 25)}...${fileExt}`
                    : fileName;
        }

        const dzProps = {
            style: {
                display: hideDz ? 'none' : 'inline-block',
            },
            multiple: this.props.multiple || false,
            accept: this.props.accept,
        };

        const wrapperCls =
            error || metaError
                ? 'dropzone-wrapper dropzone-wrapper-error'
                : 'dropzone-wrapper';

        return (
            <StyledUploader>
                <div className={wrapperCls} style={dzProps.style}>
                    <Dropzone
                        ref={c => {
                            this._dz = c;
                        }}
                        disabled={disabled}
                        onDrop={this.handleDrop}
                        {...dzProps}
                    >
                        {selectText || 'Select a file to upload...'}
                    </Dropzone>
                </div>

                {(isUploading || isProcessing) &&
                    <div className="tracker__bar">
                        <div
                            className="tracker__bar-inside tracker__bar-inside--no-min-width tracker__bar-inside--full"
                            style={{
                                transitionDuration: '300ms',
                                width: `${progress}%`,
                            }}
                        >
                            {progressText}
                        </div>
                    </div>}

                {(!isUploading || !isProcessing) &&
                    (error || metaError) &&
                    <div className="upload-error">
                        {error}&nbsp;{metaError}
                    </div>}

                {showDetails &&
                    <div className="details">
                        {this.renderImagePreview(assetField)}

                        <div className="filename">
                            <b>{prettyFilename}</b> ({prettySize})
                        </div>
                        {disableDownloadButton !== true &&
                            <button
                                className="button button--compact"
                                disabled={downloadDisabled}
                                onClick={this.onDownload}
                                title="Download"
                            >
                                Download
                            </button>}
                        {!disabled &&
                            <button
                                className="button button--compact button--spacing-left"
                                onClick={this.onClearUpload}
                                title="Clear"
                            >
                                Clear
                            </button>}
                    </div>}
            </StyledUploader>
        );
    }
}

// S3UploadField.propTypes = {
//     accept: PropTypes.any,
//     assetType: PropTypes.string.isRequired,
//     disabled: PropTypes.bool,
//     disableDownloadButton: PropTypes.bool,
//     dispatch: PropTypes.func.isRequired,
//     downloadsById: PropTypes.object,
//     meta: PropTypes.object,
//     input: React.PropTypes.shape({
//         onChange: PropTypes.func.isRequired,
//         value: PropTypes.any,
//     }),
//     maxFileSize: PropTypes.number.isRequired,
//     selectText: PropTypes.string,
//     multiple: PropTypes.bool,
// };

S3UploadField = connect((state, ownProps) => {
    // consistent reference between custom upload reducer and redux-form by using input name
    const fieldId = ownProps.input.name;

    return {
        assetField: fieldId ? state.asset.fields[fieldId] : null,
        fetchingDownloads: state.download.fetching,
        downloadUrlsById: state.download.downloadsById,
    };
})(S3UploadField);

export default S3UploadField;



// WEBPACK FOOTER //
// ./src/components/shared/forms/S3Upload.js